document.addEventListener('DOMContentLoaded', () => {
    const THRESHOLD_CENTS = 50000;
    let isProcessing = false;

    const checkMandatoryProtection = async () => {
        if (isProcessing) return;
        isProcessing = true;

        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();

            if (!cart) return;

            const isMandatory = cart.total_price >= THRESHOLD_CENTS;
            const body = document.body;

            if (isMandatory) {
                body.classList.add('is-protection-mandatory');
            } else {
                body.classList.remove('is-protection-mandatory');
            }
        } catch (error) {
            console.error("Erreur Navidium :", error);
        } finally {
            setTimeout(() => { isProcessing = false; }, 500);
        }
    };

    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
        const response = await originalFetch.apply(this, args);
        const url = args[0] || '';
        if (typeof url === 'string' && (url.includes('/cart') || url.includes('cart.js'))) {
            setTimeout(checkMandatoryProtection, 400);
        }
        return response;
    };

    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
        this.addEventListener('load', () => {
            if (typeof url === 'string' && url.includes('/cart')) {
                setTimeout(checkMandatoryProtection, 400);
            }
        });
        return originalOpen.apply(this, arguments);
    };

    setTimeout(checkMandatoryProtection, 800);
});